const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0]!.toUpperCase())
    .join('')
    .slice(0, 2);

export function Avatar({
  name,
  photoUrl,
  colour,
  size = 'md',
}: {
  name: string;
  photoUrl?: string | null;
  colour?: string;
  size?: 'sm' | 'md' | 'xl';
}) {
  return (
    <span
      className={`avatar${size !== 'md' ? ` avatar--${size}` : ''}`}
      style={colour ? { ['--av' as string]: colour } : undefined}
      aria-hidden="true"
    >
      {photoUrl ? <img src={photoUrl} alt="" loading="lazy" /> : initials(name)}
    </span>
  );
}

/**
 * Model picture: the uploaded photo, else a drawn fan in the model's colour with the
 * right blade count — so nobody has to read model codes (PRD "Pictures for models").
 */
export function ModelThumb({
  hex,
  blades,
  photoUrl,
  size = 52,
}: {
  hex: string;
  blades: number;
  photoUrl?: string | null;
  size?: number;
}) {
  if (photoUrl) {
    return (
      <span className="thumb" style={{ width: size, height: size }}>
        <img src={photoUrl} alt="" loading="lazy" width={size} height={size} />
      </span>
    );
  }
  const b = Math.max(2, Math.min(6, blades));
  return (
    <svg className="thumb" width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="13" style={{ fill: 'var(--surface-2)' }} />
      <g style={{ fill: hex, stroke: 'var(--fan-stroke)', strokeWidth: 1.2 }}>
        {Array.from({ length: b }, (_, i) => (
          <ellipse
            key={i}
            cx="32"
            cy="14"
            rx="6.2"
            ry="11.5"
            transform={`rotate(${((i * 360) / b).toFixed(1)} 32 32)`}
          />
        ))}
      </g>
      <circle cx="32" cy="32" r="8.5" style={{ fill: hex, stroke: 'var(--fan-stroke)', strokeWidth: 1.2 }} />
      <circle cx="32" cy="32" r="2.6" style={{ fill: 'var(--fan-stroke)' }} />
    </svg>
  );
}
